var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64648 0.75C6.97455 0.750076 7.30219 0.827438 7.5957 0.974609L9.96289 2.1582L10.0557 2.19824C10.1504 2.23249 10.2519 2.25 10.3535 2.25H15.624C17.6228 2.25 19.25 3.87611 19.25 5.875V14.125C19.25 16.1238 17.6238 17.75 15.625 17.75H4.375C2.37618 17.75 0.75 16.1238 0.75 14.125V4.375L0.754883 4.18848C0.852293 2.27599 2.43873 0.75 4.375 0.75H6.64648ZM2 14.125C2 15.4344 3.06557 16.5 4.375 16.5H15.625C16.9344 16.5 18 15.4344 18 14.125V6.5H2V14.125ZM4.37598 2C3.06645 2 2 3.06566 2 4.375V5.25H17.9141C17.639 4.24299 16.7176 3.5 15.625 3.5H10.3535C10.1074 3.49994 9.86131 3.45691 9.62988 3.37305L9.4043 3.27539L7.03711 2.0918C6.9172 2.03155 6.78209 2 6.64648 2H4.37598Z",
    fill: "#26445A",
    stroke: "#26445A",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/Battery.7ec587dec67609b4d41ba308cd4e5d71.svg";
export { ForwardRef as ReactComponent };